import { BaseAPIModel } from '@weezevent/weezjs-core';

export class Event extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) return `/ticket/events`;
        return `/ticket/organizations/${organizationId}/events`;
    }

    get organizationId() {
        if (!this.object.organization_id) {
            return this.object.organizations[0]?.id;
        }
        return this.object.organization_id;
    }

    getSafeName(t) {
        if (!this.name) {
            return t('sauron.events.event_without_name');
        }
        return this.name;
    }

    getStatusInfo() {
        switch (this.time_status) {
            case 'over':
                return { text: 'over', css: 'error' };
            case 'upcoming':
                return { text: 'upcoming', css: 'future' };
            default:
                return { text: 'ongoing', css: 'valid' };
        }
    }
}
